import React from 'react';
import { IAddressWithCoordinate } from 'Modules/SearchAddress/types';
import styled from 'styled-components';
import HighlightText, { HighlightWrapper } from 'Components/HighlightText';
import { Flex, Box } from '@igooods/ui-kit';
import { FontSize } from 'theme';
import CloseButtonIcon from 'Components/Icon/CloseButtonIcon';
import timeImg from './img/time.svg';
import { colors } from 'constants/colors';

interface ISearchHistory {
  onClick: (address: IAddressWithCoordinate) => void;
  onRemove?: (address: IAddressWithCoordinate) => void;
  list: IAddressWithCoordinate[];
}

export const StyledHighlightText = styled(HighlightText)`
  ${HighlightWrapper} {
    line-height: 18px;
    position: relative;
    padding-left: 25px;
    &:before {
      content: '';
      position: absolute;
      left: 0;
      top: calc(50% - 8px);
      width: 17px;
      height: 16px;
      background: url(${timeImg}) center/contain no-repeat;
      margin-right: 8px;
    }
  }
`;

export const RemoveBtn = styled(Box).attrs({ px: 2, pt: 1, mr: -2 })`
  margin-left: auto;
`;

const SearchHistoryList: React.FC<ISearchHistory> = ({ onRemove, onClick, list }: ISearchHistory) => {
  return (
    <Flex column>
      {list.map((item, i) => (
        <Flex key={`${item.name}${i}`}>
          <StyledHighlightText size={FontSize.s} onClick={() => onClick(item)} title={item.name} />
          {onRemove && (
            <RemoveBtn onClick={() => onRemove(item)}>
              <CloseButtonIcon color={colors.blackRussian} width="8px" height="8px" />
            </RemoveBtn>
          )}
        </Flex>
      ))}
    </Flex>
  );
};

export default SearchHistoryList;
